export default [
  {
    path: "/arsiv",
    name: "arsiv",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "arsiv.Baslik",
      yetki: { k: [2002702] },
    },
  },
]
